import { render, staticRenderFns } from "./RadioYesNo.vue?vue&type=template&id=7074dec6"
import script from "./RadioYesNo.vue?vue&type=script&lang=js"
export * from "./RadioYesNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports